export default {"src":"/_next/static/media/icon-linkedin.e8fd5eee.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};